import React, { useState } from "react";
import "./HeaderV2.scss";
import { useNavigate, Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { ClickAwayListener } from "@mui/base";

const leapon_logo =
  "https://leapon-media.s3.amazonaws.com/media/webp_images/Group_1_png.webp";
const logo_white =
  "https://leapon-media.s3.amazonaws.com/media/webp_images/Group_2_png.webp";

function HeaderV2(props) {
  const navigate = useNavigate();
  const [showMenu, SetShowMenu] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const pathname = window.location.pathname;

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <nav className="header_con">
      <div className="header_con_wrapper">
        <img
          src={props.isDark ? logo_white : leapon_logo}
          effect="blur"
          className={
            "header_logo " + (props.isDark ? "header_logo_white" : "")
          }
          alt="Leapon main logo"
          role="button"
          tabIndex="0"
          onClick={() => navigate("/")}
        />
        {!props.hide_btn ? (
          <>
            <div
              className={
                "header_con_mid " + (props.isDark ? "header_con_mid_dark" : "")
              }
              style={isHovered ? { height: 175 } : { height: 60 }}
            >
              <div className="header_con_mid_wrapper">
                <div
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  className={
                    "header_hover_btn " + (isHovered ? "active_btn" : "")
                  }
                >
                  <span>Product</span>
                  <div
                    style={isHovered ? { opacity: 1 } : { opacity: 0 }}
                    className={"header_con_mid_wrapper2"}
                  >
                    <button
                      className={
                        pathname === "/digital-business-card"
                          ? "active_btn"
                          : ""
                      }
                      onClick={() => navigate("/digital-business-card")}
                    >
                      Digital Business Card
                    </button>
                    <button
                      className={
                        pathname === "/smart-contact-management"
                          ? "active_btn"
                          : ""
                      }
                      onClick={() => navigate("/smart-contact-management")}
                    >
                      Smart Contact Management
                    </button>
                  </div>
                </div>
                <button
                  className={pathname === "/pricing" ? "active_btn" : ""}
                  onClick={() => navigate("/pricing")}
                >
                  Pricing
                </button>
                <button
                  className={pathname === "/blog" ? "active_btn" : ""}
                  onClick={() => navigate("/blog")}
                >
                  Blog
                </button>
                <button
                  className={pathname === "/get-demo" ? "active_btn" : ""}
                  onClick={() => navigate("/get-demo")}
                >
                  Get a Demo
                </button>
              </div>
            </div>
            <div
              className={
                "header_con_right " +
                (props.isDark ? "header_con_right_dark" : "")
              }
            >
              <Link to="https://leapon.me/login" className="btn_1">
                Sign in
              </Link>
              <Link
                to="https://leapon.me/signup/"
                className="btn_2 btn-primary"
              >
                Free Trial
              </Link>
            </div>

            <ClickAwayListener onClickAway={() => SetShowMenu(false)}>
              <div className="header_con_mobile">
                <Link className="btn-primary" to="https://leapon.me/signup/">
                  Free Trial
                </Link>
                <button
                  className={"menu_btn " + (showMenu ? "menu_btn_active" : "")}
                  onClick={() => SetShowMenu(!showMenu)}
                >
                  <MenuIcon className="icon" />
                </button>
                <div className={"hideMenu " + (showMenu ? "showMenu" : "")}>
                  <button onClick={() => navigate("/digital-business-card")}>
                    Digital Business Card
                  </button>
                  <button onClick={() => navigate("/smart-contact-management")}>
                    Smart Contact Management
                  </button>
                  <button onClick={() => navigate("/pricing")}>Pricing</button>
                  <button onClick={() => navigate("/blog")}>Blog</button>
                  <button onClick={() => navigate("/get-demo")}>
                    Get a Demo
                  </button>
                  <Link to="https://leapon.me/login" className="btn-primary">
                    Sign in
                  </Link>
                </div>
              </div>
            </ClickAwayListener>
          </>
        ) : (
          <button onClick={() => navigate("/contact-sales")} className="btn_contact">Contact Us</button>
        )}
      </div>
    </nav>
  );
}

export default HeaderV2;
